/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import DataTable from 'react-data-table-component';
import { columns } from './tableHeaders/sch';

type PropsType = {
  progressPending: boolean,
  data: [],
  handleToggleModal: (boolean, {}) => void,
  handleToggleSchStatus: () => void,
  isFetching: boolean
};

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  }
};

const SCHBody = (props: PropsType): React.Element<'div'> => {
  const CustomLoader = (): React.Element<'div'> => (
    <div className='csspinner' style={{ width: '50px', height: '50px' }} />
  );

  /* eslint-disable */
  _.map(props.data, (di: {}) => {
    switch (di.type) {
      case 'MerchantThreeDayReminder':
        di.type = '3 days before event';
        break;
      case 'MerchantOneDayReminder':
        di.type = '1 days before event';
        break;
      case 'AttendeeThreeDayReminder':
        di.type = '3 days before event';
        break;
      case 'AttendeeOneDayReminder':
        di.type = '1 days before event';
        break;
      case 'Customize':
        di.type = 'Recent';
        break;
      default:
        //
    }
  });
  /* eslint-enable */
  const _columns = columns(props.handleToggleModal, props.handleToggleSchStatus);

  return (
    <div className="panel-body">
      <div style={{ position: 'relative', minHeight: '120px' }}>
        <div style={{ width: '100%', overflowX: 'auto', position: 'relative' }}>
          <DataTable
            columns={_columns}
            data={props.data}
            customStyles={customStyles}
            highlightOnHover
            responsive
            striped
            fixedHeader
            noHeader
            progressPending={props.progressPending}
            progressComponent={<CustomLoader />}
            sortIcon={(): React.Element<typeof React.Fragment> => {
              return (
                <>
                  <span className="-sort-desc" />
                  <span className="-sort-asc" />
                </>
              );
            }}
          />

          {props.isFetching &&
            <div style={{
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(255,255,255, .3)'
            }}
            >
              <div className='csspinner' style={{ width: '50px', height: '50px' }} />
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default SCHBody;
